export default {"src":"/_next/static/media/chevron_up.6feab87d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};